import React from 'react'
import './coursec.css';
import { Link } from 'react-router-dom';

import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import course1 from '../assests/course1.jpg';
import course2 from '../assests/course2.jpg';
import course3 from '../assests/course3.jpg';
import course4 from '../assests/course4.jpg';
import course5 from '../assests/course5.jpg';
import course6 from '../assests/course6.jpg';
import course7 from '../assests/course7.jpg';
import course8 from '../assests/course8.jpg';
import course9 from '../assests/course9.jpg';

function courses() {
  return (
    <div>
        <div className="coursessec">
            <div className="introabout">
                <p className="abouttitle">Courses</p>
                <p className="subabout">Home <span><ArrowForwardIosIcon className='spanicon' /><ArrowForwardIosIcon className='spanicon1' /></span> Courses</p>
            </div>
        </div>

          <div className="imagescontainter">
              <div className="imagessec">
                  <div><img src={course1} width="250" height="200" alt="course1" />
                  <Link target={"_blank"} to="Tally Training Institute"><p className="courseone">Tally Training Institute</p></Link>
                  </div>
                  <div><img src={course2} width="250" height="200" alt="course1" />
                  <Link target={"_blank"} to="Storage Management"><p className="courseone">Storage Management</p></Link>
                  </div>
                  <div><img src={course3} width="250" height="200" alt="course1" />
                  <Link target={"_blank"} to="Wifi Setup"><p className="courseone">Wifi Setup</p></Link>
                  </div>
              </div>


              <div className="imagessec">
                  <div><img src={course4} width="250" height="200" alt="course1" />
                  <Link target={"_blank"} to="Server Management"><p className="courseone">Server Management</p></Link>
                  </div>
                  <div><img src={course5} width="250" height="200" alt="course1" />
                  <Link target={"_blank"} to="Cloud Computing"><p className="courseone">Cloud Computing</p></Link>
                  </div>
                  <div><img src={course6} width="250" height="200" alt="course1" />
                  <Link target={"_blank"} to="CCTV System Training"><p className="courseone">CCTV System Training</p></Link>
                  </div>
              </div>


              <div className="imagessec">
                  <div><img src={course7} width="250" height="200" alt="course1" />
                  <Link target={"_blank"} to="Advance System"><p className="courseone">Advance System</p></Link>
                  </div>
                  <div><img src={course8} width="250" height="200" alt="course1" />
                  <Link target={"_blank"} to="Desktop Management"><p className="courseone">Desktop Management</p></Link>
                  </div>
                  <div><img src={course9} width="250" height="200" alt="course1" />
                  <Link target={"_blank"} to="Thin Client Solution"><p className="courseone">Thin Client Solution</p></Link>
                  </div>
              </div>


              <div className="imagessec">
                  <div><img src={course1} width="250" height="200" alt="course1" />
                  <Link target={"_blank"} to="Tally Training Institute"><p className="courseone">Tally Training Institute</p></Link>
                  </div>
                  <div><img src={course2} width="250" height="200" alt="course1" />
                  <Link target={"_blank"} to="Tally Training Institute"><p className="courseone">Storage Management</p></Link>
                  </div>
                  <div><img src={course3} width="250" height="200" alt="course1" />
                  <Link target={"_blank"} to="Tally Training Institute"><p className="courseone">Wifi Setup</p></Link>
                  </div>
              </div>
          </div>

    </div>
  )
}

export default courses